// extracted by css-extract-rspack-plugin
export default {"renderedInput":"suggested-item-picker-module__renderedInput__szBuX"};